import { render, staticRenderFns } from "./add-exams.vue?vue&type=template&id=ac819632"
import script from "./add-exams.vue?vue&type=script&lang=js"
export * from "./add-exams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports